module.exports = "/_next/static/images/0e128405a49e87e2248cc32e1771d7ba-hero-100m-tablet.jpg.webp";